import { render } from "./DateCard.vue?vue&type=template&id=436abb77&scoped=true"
import script from "./DateCard.vue?vue&type=script&lang=js"
export * from "./DateCard.vue?vue&type=script&lang=js"

import "./DateCard.vue?vue&type=style&index=0&id=436abb77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436abb77"]])

export default __exports__